// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cltglxlfgzukecingrur.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNsdGdseGxmZ3p1a2VjaW5ncnVyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDAzNjg1MjAsImV4cCI6MjA1NTk0NDUyMH0.9B9OjGbKuOYZ6kA4L6UouyrmvRhi44jMHU0IM_ZwxMs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Create the Supabase client with the appropriate options
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
  },
  global: {
    // Set sensible timeouts to prevent early failures
    fetch: (url, options) => {
      const timeout = 30000; // 30 seconds timeout
      const controller = new AbortController();
      const id = setTimeout(() => controller.abort(), timeout);
      
      return fetch(url, {
        ...options,
        signal: controller.signal,
      }).finally(() => {
        clearTimeout(id);
      });
    },
  },
});